import { render, staticRenderFns } from "./public-card.vue?vue&type=template&id=60acec17&scoped=true&"
import script from "./public-card.vue?vue&type=script&lang=js&"
export * from "./public-card.vue?vue&type=script&lang=js&"
import style0 from "./public-card.vue?vue&type=style&index=0&id=60acec17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acec17",
  null
  
)

export default component.exports